import { Container } from "react-bootstrap";
import Dropdown from "react-bootstrap/Dropdown";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { BiLogOut } from "react-icons/bi";
import { WEB_ROUTES } from "../../constants";
import styles from "./styles/Navbar.module.scss";
import { useSelector } from "react-redux";
import { useState } from "react";
import { useEffect } from "react";

export default function CustomNavbar({
  isSearchBar = true,
  isSettingButton = false,
  handleToggle,
  onClickLogout,
}) {
  const [userName, setUserName] = useState("");
  const [profileImage, setProfileImage] = useState("");

  const user = useSelector((state) => state.auth.user);

useEffect(() => {
  if(user){
    setUserName(`${user.firstname} ${user.lastname}`);
    setProfileImage(user.image_url);
  }
}, [user])


  return (
    <Navbar collapseOnSelect expand="lg" className="gradientBg">
      <Container className="text-white ">
        <Navbar.Brand href={WEB_ROUTES.DASHBOARD}>
          <img
            src={"/images/small_logo.png"}
            alt="Logo"
            className={styles.imageNotCollapsed}
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link href={WEB_ROUTES.ALL_CATEGORIES}>All Categories</Nav.Link>
            {
              // <Nav.Link href="#pricing">Pricing</Nav.Link>
            }
          </Nav>
          <Nav>
            {
              // <NavDropdown title="Dropdown" id="collapsible-nav-dropdown">
              //   <NavDropdown.Item href="#action/3.1">Action</NavDropdown.Item>
              //   <NavDropdown.Item href="#action/3.2">
              //     Another action
              //   </NavDropdown.Item>
              //   <NavDropdown.Item href="#action/3.3">Something</NavDropdown.Item>
              //   <NavDropdown.Divider />
              //   <NavDropdown.Item href="#action/3.4">
              //     Separated link
              //   </NavDropdown.Item>
              // </NavDropdown>
            }
            {
              // <Nav.Link href="#deets">More deets</Nav.Link>
              // <Nav.Link eventKey={2} href="#memes">
              // Dank memes
              // </Nav.Link>
            }
            <Dropdown>
              <div className="d-flex flex-row">
                <b className="my-auto">{userName}</b>
                <Dropdown.Toggle id="dropdown-basic">
                  <img
                    src={profileImage}
                    alt="Logo"
                    className={styles.profileImage}
                  />
                </Dropdown.Toggle>
              </div>

              <Dropdown.Menu>
                {
                  // <Dropdown.Item href="#/action-1">Action</Dropdown.Item>
                  // <Dropdown.Item href="#/action-2">Another action</Dropdown.Item>
                  // <Dropdown.Item href="#/action-3">Something else</Dropdown.Item>
                }
                <Dropdown.Item onClick={onClickLogout}>
                  <BiLogOut /> Logout
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}
